<template>
  <div class="d-flex flex-wrap ">
      <div class="col-md-12" >
        <b-tabs v-model="tabIndex">
        <b-tab :title="'Detalhes'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 text-third">Detalhes</span></div>
            </template>
            <Detailaccredited :editData="dataedit" ></Detailaccredited>

        </b-tab>
        <b-tab :title="'Valor de Empreeedimento'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 text-third">Corretores</span></div>
            </template>
            <Tablebrokers :id="dataedit.id"></Tablebrokers>
        </b-tab>
        <b-tab :title="'Comissoes'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 text-third">Empreedimentos</span></div>
            </template>
            <Tableenterprise  :dataAll="dataedit" v-on:update="update" :id="dataedit.id"></Tableenterprise>
        </b-tab>
        </b-tabs>
      </div>
  </div>
</template>

<script>
import Painelaccredited from './painelaccredited'
export default Painelaccredited
</script>

<style scoped>

.text-tabs{
    font-size: 16px;
    margin-left: 5px;
    font-weight: bold;
    margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/painelaccredited/painelaccredited.vue